export default "__VITE_ASSET__CCGq3aqA__";